import axios from "axios";
import { FileWithPath } from "react-dropzone";
import server from "../api";

interface IBody {
  contentType: string;
  fileName: string;
  uploadType: string;
}

export const getSignedUrl = async (body: IBody) => {
  try {
    const response = await server.post("/v1/upload/getSignedUrl", body);
    if (response?.data) {
      return response.data;
    }
  } catch (error) {
    console.log("getSignedUrl error", error);
    throw error;
  }
};

export const uploadFileToS3 = async (url: string, file: FileWithPath) => {
  try {
    await axios({
      method: "put",
      url,
      headers: {
        "Content-Type": file.type,
      },
      // converting from blob to binary form
      data: await file.arrayBuffer(),
    });
  } catch (error) {
    console.log("uploadFileToS3 error", error);
    throw error;
  }
};

export const mediaUploadHandler = async (
  file: FileWithPath,
  uploadType = ""
) => {
  try {
    const body = {
      fileName: file.name,
      uploadType,
      contentType: file.type,
    };
    const signedUrlData = await getSignedUrl(body);
    if (signedUrlData?.url) {
      await uploadFileToS3(signedUrlData.url, file);
      return signedUrlData.fileKey;
    }
  } catch (error) {
    console.log("mediaUploadHandler error", error);
    throw error;
  }
};
